@import '../../../globals/main.scss';

pn-spotlight {
  .pn-spotlight__container {
    overflow: hidden;

    @media screen and (max-width: 991px) {
      //cover viewport width regardless of parent margins
      margin-left: calc(-50vw + 50%);
      margin-right: calc(-50vw + 50%);
    }
  }

  [slot='mobile-heading'] {
    text-align: center;
    padding-bottom: 1.6rem;
    font-weight: 500;
    color: $blue900;
    @media screen and (min-width: 769px) {
      display: none;
    }
  }

  .pn-spotlight__container__wrapper {
    position: relative;
    max-width: 100%;

    @media screen and (min-width: $min-width-lg) {
      max-width: 90%;
      margin: 0 auto;
    }

    @media screen and (min-width: $min-width-xxl) {
      max-width: 80%;
    }
  }

  .pn-spotlight__container__wrapper__content {
    position: relative;
    margin: 0 auto;

    display: flex;
    flex-direction: row;
    left: -57.5px;
    width: calc(100% + 57.5px);

    @media screen and (min-width: $min-width-md) {
      left: -50px;
      width: calc(100% + 50px);
    }

    @media screen and (min-width: $min-width-lg) {
      left: 0;
      width: 100%;
    }
  }

  .pn-spotlight__container__wrapper__content__ball {
    border-radius: 50%;
    min-height: 75px;
    aspect-ratio: 1 / 1;
    margin-right: 1.5rem;

    @media screen and (min-width: $min-width-md) {
      min-height: 85px;
      margin-right: 2.5rem;
    }

    @media screen and (min-width: $min-width-lg) {
    }

    @media screen and (min-width: $min-width-xl) {
    }

    @media screen and (min-width: $min-width-xxl) {
    }
  }

  [slot='content'] {
    display: flex;
    border-top-left-radius: 10rem;
    border-bottom-left-radius: 10rem;
    align-items: center;
    justify-content: right;
    padding: 0 1.5rem;
    padding-left: 50px;
    width: 100%;

    @media screen and (min-width: $min-width-md) {
    }

    @media screen and (min-width: $min-width-lg) {
      padding: 0 2rem;
      border-radius: 10rem;
    }
  }
}

//dynamic cta
.pn-spotlight__container__wrapper.cta--dynamic {
  @media screen and (min-width: $min-width-lg) {
    width: fit-content;
  }

  [slot='content'] {
    @media screen and (min-width: $min-width-lg) {
      padding-left: 4rem;
    }
  }
}

//colors

pn-spotlight[data-cta-color='green'] {
  [slot='content'] {
    background-color: $green50;
  }

  .pn-spotlight__container__wrapper__content__ball {
    background-color: $green50;
  }
}

pn-spotlight[data-cta-color='coral'] {
  [slot='content'] {
    background-color: $coral50;
  }

  .pn-spotlight__container__wrapper__content__ball {
    background-color: $coral50;
  }
}

pn-spotlight[data-cta-color='blue'] {
  [slot='content'] {
    background-color: $blue25;
  }

  .pn-spotlight__container__wrapper__content__ball {
    background-color: $blue25;
  }
}

pn-spotlight[data-cta-color='business'] {
  [slot='content'],
  .pn-spotlight__container__wrapper__content__ball {
    background-color: $blue900;
  }
}

pn-spotlight[data-cta-color='private'] {
  [slot='content'],
  .pn-spotlight__container__wrapper__content__ball {
    background-color: $blue400;
  }
}

pn-spotlight[data-cta-color='hybrid'] {
  [slot='content'],
  .pn-spotlight__container__wrapper__content__ball {
    background-color: #e9e6e5;
  }
}
